import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StockState } from './stock.reducer';

export const selectStockState = createFeatureSelector<StockState>('stock');

export const selectStockItems = createSelector(selectStockState, (s) => s.items);
export const selectStockLoading = createSelector(selectStockState, (s) => s.loading);
export const selectStockLoaded = createSelector(selectStockState, (s) => s.loaded);
export const selectStockError = createSelector(selectStockState, (s) => s.error);
